<template>
  <SettingPanel
    title="Auto close ticket (By admin)"
    :subheader="$t('auto_close_ticket_remark')"
    :loading="loading"
  >
    <template #edit="{ done }">
      <AdminAutoCloseTicketManagement
        :value="config"
        @submit="handleSubmit(() => done())"
        @close="done()"
      />
    </template>
  </SettingPanel>
</template>

<script>
import { mapGetters } from 'vuex'
import ticket3PageApi from '@/api/ticket3/page'
import SettingPanel from './SettingPanel.vue'
import AdminAutoCloseTicketManagement from './AdminAutoCloseTicketManagement.vue'

export default {
  components: { SettingPanel, AdminAutoCloseTicketManagement },
  data() {
    return {
      config: undefined,
      loading: true
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  async created() {
    this.$store.dispatch('loadCategory')
    this.$store.dispatch('loadProducts')
    this.$store.dispatch('loadSetting')
    this.fetchData()
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true

        const response = await ticket3PageApi.getAdminFollowUpConfig({
          params: {
            page_id: this.selectedBot.pageid
          }
        })

        const { ticket_v3_admin_follow_up_config } = response.data

        this.config = ticket_v3_admin_follow_up_config || undefined
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    handleSubmit(callback) {
      callback()
      this.fetchData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/Setting/AdminAutoCloseTicket.vue